import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { HeaderUnLoggedIn } from 'scenes/Header';
import FooterRegistration from 'components/FooterRegistration';

import * as actions from 'store/modules/auth/actions';
import { SIGN_UP_PATH } from 'routes';

import AlertMessage from 'components/AlertMessage';

import EditPasswordForm from './EditPasswordForm';

class EditPasswordPage extends Component {
  state = {
    showAlert: false,
    alertText: '',
  };
  handleUpdatePassword = async (values, setSubmitting, setErrors) => {
    const body = {
      user: {
        password: values.password,
        password_confirmation: values.password_confirmation,
        reset_password_token: values.reset_password_token,
      },
    };
    const response = await this.props.sendUpdatePasswordAction(
      body,
      setSubmitting,
      setErrors,
    );
    if (response.status === 200 && response.data.email) {
      await this.props.signInAction(
        response.data.email,
        body.user.password,
        setSubmitting,
        setErrors,
      );
      this.setState({ showAlert: true });
      this.setState({ alertText: 'Password has been successfully updated!' });
      setTimeout(() => {
        this.setState({ showAlert: false });
      }, 4000);
    }
  };

  render() {
    const { showAlert, alertText } = this.state;
    return (
      <div className="b-row register">
        <div className="b-col-8 b-col-sm-12">
          <div className="register__left">
            <HeaderUnLoggedIn />
            <EditPasswordForm handleSubmit={this.handleUpdatePassword} />
          </div>
        </div>
        {showAlert && <AlertMessage text={alertText} />}
        <div className="b-col-4 b-col-sm-12 register-bg">
          <div className="register-bg__top">
            <div className="register-bg__text m-r-15">
              Don’t have an account?
            </div>
            <Link to={SIGN_UP_PATH} className="btn btn-white outline">
              Sign up
            </Link>
          </div>
          <div className="register-bg__inner">
            <h2 className="register-bg__title">
              You only have one link. <br /> Make it count
            </h2>
            <div className="register-bg__text">Do you have questions? </div>
            <Link to="/contact" className="btn btn-white m-t-30">
              Contact us
            </Link>
          </div>
        </div>
        <FooterRegistration />
      </div>
    );
  }
}

export default connect(
  null,
  actions,
)(EditPasswordPage);



// WEBPACK FOOTER //
// ./src/scenes/EditPassword/EditPasswordPage.js